module.exports = __webpack_public_path__ + "static/media/step3.31d78bda.svg";